module.exports = __webpack_public_path__ + "media/3.b10460ca.wav";